import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminAuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          { session_id: sid },
          { withCredentials: true }
        );
        // Clear the hash so it isn't re-processed
        window.history.replaceState(null, "", window.location.pathname);
        if (r.data?.is_admin) {
          navigate("/admin", { replace: true, state: { user: r.data.user } });
        } else {
          navigate("/admin/login?error=not_authorized", { replace: true });
        }
      } catch (_) {
        navigate("/admin/login?error=not_authorized", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-ink-900 text-white flex items-center justify-center">
      <div className="text-gold-pale tracking-wider text-sm animate-pulse" data-testid="admin-auth-callback-loading">
        Finalizing sign-in…
      </div>
    </div>
  );
}
